import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.async-iterator.for-each.js";
import "core-js/modules/esnext.iterator.for-each.js";
import _extends from "/app/node_modules/.pnpm/next@15.1.4_@babel+core@7.26.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_7e2b6puiko2szsfxy4a5sgzu7u/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/app/node_modules/.pnpm/next@15.1.4_@babel+core@7.26.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_7e2b6puiko2szsfxy4a5sgzu7u/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@15.1.4_@babel+core@7.26.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_7e2b6puiko2szsfxy4a5sgzu7u/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "hash", "linkEntity", "query", "target"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { routes } from "scmp-app/lib/router";
import { getIsSubSection, shouldRedirectBaseDynamicSectionLink } from "scmp-app/lib/router/helpers";
import { RouteType, useRouteDetector } from "scmp-app/lib/router/hooks";
import { BaseLink } from "shared/components/common/base-link";
import { getAbsoluteUrl } from "shared/lib/utils";
export const BaseEntityLink = /*#__PURE__*/React.forwardRef((props, reference) => {
  var _renderMap$getRouteTy;
  const {
      children,
      hash,
      linkEntity,
      query: queryProps,
      target
    } = props,
    remainingProps = _objectWithoutProperties(props, _excluded);
  const renderLink = _ref => {
    let {
      hash,
      isAnchor,
      linkAs,
      pathname,
      query,
      target = "_self"
    } = _ref;
    return __jsx(BaseLink, _extends({}, remainingProps, {
      anchorProps: _objectSpread({
        target
      }, props.anchorProps),
      as: linkAs,
      hash: hash,
      isAnchor: isAnchor,
      pathname: pathname,
      query: _objectSpread(_objectSpread({}, query), queryProps),
      ref: reference,
      "data-qa": "BaseEntityLink-renderLink-BaseLink"
    }), children);
  };
  const {
    entityId,
    parentSection,
    routeType: routeTypeInEntity = "",
    urlAlias,
    urlRedirectPath
  } = linkEntity;
  const defaultRenderLink = renderLink({
    pathname: urlAlias
  });
  const renderMap = {
    [RouteType.DrupalRedirect]: () => renderLink({
      pathname: getAbsoluteUrl(urlAlias)
    }),
    [RouteType.Dynamic]: () => {
      const typeName = routeTypeInEntity === "Section" && getIsSubSection({
        entityId,
        parentSection
      }) ? "SubSection" : routeTypeInEntity;
      const matched = routes.dynamics[typeName];
      const {
        pathname,
        query
      } = matched.route(entityId);
      return renderLink({
        hash,
        isAnchor: shouldRedirectBaseDynamicSectionLink(pathname, queryProps),
        linkAs: urlAlias,
        pathname,
        query,
        target
      });
    },
    [RouteType.ExternalDomain]: () => renderLink({
      pathname: urlAlias,
      target: "_blank"
    }),
    [RouteType.InternalDomain]: () => defaultRenderLink,
    [RouteType.Other]: () => defaultRenderLink,
    [RouteType.Redirect]: () => renderLink({
      pathname: getAbsoluteUrl(urlRedirectPath)
    }),
    [RouteType.Static]: () => defaultRenderLink
  };
  const {
    getRouteTypeByRouteEntity
  } = useRouteDetector();
  return (_renderMap$getRouteTy = renderMap[getRouteTypeByRouteEntity(linkEntity)]) === null || _renderMap$getRouteTy === void 0 ? void 0 : _renderMap$getRouteTy.call(renderMap);
});
BaseEntityLink.displayName = "BaseEntityLink";